module.exports = __webpack_public_path__ + "static/media/refurbishConservatory.593bc408.jpg";